// extracted by mini-css-extract-plugin
export default {"content-layout":"ContentLayout_content-layout__QbG6-"};